<script>
export default {
  data () {
    return {
      rangeoption1: {
        // tooltip: {
        //   trigger: 'axis',
        //   formatter: function (params) {
        //     var relVal = params[0].name
        //     for (var i = 0, l = params.length; i < l; i++) {
        //       relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'V'
        //     }
        //     return relVal
        //   }
        // },
        legend: {
          data: ['Ua', 'Ub', 'Uc'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 40
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          name: 'ms',
          data: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '20', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '40', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '60'],
          axisLabel: {
            show: true,
            interval: 0
          },
          axisTick: {
            show: false
          }
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: [{
          name: 'Ua',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: []
        }, {
          name: 'Ub',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: []
        }, {
          name: 'Uc',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: []
        }
        ]
      },
      rangeoption2: {
        // tooltip: {
        //   trigger: 'axis',
        //   formatter: function (params) {
        //     var relVal = params[0].name
        //     for (var i = 0, l = params.length; i < l; i++) {
        //       relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'A'
        //     }
        //     return relVal
        //   }
        // },
        legend: {
          data: ['Ia', 'Ib', 'Ic', 'In'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 40
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          name: 'ms',
          data: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '20', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '40', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '60'],
          axisLabel: {
            show: true,
            interval: 0
          },
          axisTick: {
            show: false
          }
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: [{
          name: 'Ia',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: []
        }, {
          name: 'Ib',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: []
        }, {
          name: 'Ic',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: []
        }, {
          name: 'In',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#00a1f5'
          },
          data: []
        }
        ]
      },
      chart: {},
      // 电气量下拉框
      posSelectOptions: [{
        value: 1,
        label: '电压'
      }, {
        value: 2,
        label: '电流'
      }],
      posSelectValue: 1,
      currentWaveData: {
        a: [],
        b: [],
        c: [],
        n: []
      },
      interval: null,
      lastTs: 0,
      commandInterval: null
    }
  },
  watch: {
    posSelectValue (val) {
      // if (val === 1) {
      this.Chart.clear()
      // } else if (val === 2) {
      //   this.Chart.clear()
      // }
      this.updateData()
    },

    '$store.state.highSpdMode' () {
      this.pollCommand()
    }
  },
  computed: {
  },
  mounted () {
    // this.setXAxis()
    this.Chart = this.$echarts.init(document.getElementById('rangeOptions'))
    this.updateData()
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.$api.getTs({
          collection: 'meter_current_data',
          sn: this.$store.state.sn
        }).then((res) => {
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg)
            return
          }
          if (this.lastTs !== res.data.data.ts) {
            this.lastTs = res.data.data.ts
            this.updateData()
          }
        })
      }, 1000)
    }
    this.pollCommand()
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    this.pollStop()

    // 关闭快速模式
    if (this.commandInterval) {
      clearInterval(this.commandInterval)
      this.commandInterval = null
    }
    this.$store.commit('updateSpeedMode', '普通模式')
  },
  methods: {
    pollCommand () {
      if (this.$store.state.reqMode === 'udp' || this.$store.state.highSpdMode) {
        this.sendCommand()
        if (!this.commandInterval) {
          this.commandInterval = setInterval(() => {
            this.sendCommand()
          }, 600000)
        }
      } else {
        this.pollStop()
      }
    },
    pollStop () {
      if (this.commandInterval) {
        clearInterval(this.commandInterval)
        this.commandInterval = null
      }
    },
    sendCommand () {
      this.$api.command({
        sn: this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        lists: [[1, 6, 3]]
      }).then(res => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
        }
      })
    },
    async updateData () {
      var max = 0
      var params = {
        'collection': '',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'fields': []
      }
      var data = {}

      if (this.posSelectValue === 1) {
        params.collection = 'meter_current_data'
        params.fields = ['current_wave_ua', 'current_wave_ub', 'current_wave_uc']
        data = await this.$api.queryLastData(params)
        if (data.data.code !== 0) {
          this.$message.error(data.data.msg)
        } else {
          for (let i = 0; i < data.data.data.current_wave_ua.length; i++) {
            if (max < data.data.data.current_wave_ua[i]) max = data.data.data.current_wave_ua[i]
            if (max < data.data.data.current_wave_ub[i]) max = data.data.data.current_wave_ub[i]
            if (max < data.data.data.current_wave_uc[i]) max = data.data.data.current_wave_uc[i]
          }
          if (max > 1000) {
            for (let i = 0; i < data.data.data.current_wave_ua.length; i++) {
              this.currentWaveData.a[i] = data.data.data.current_wave_ua[i] * 0.001
              this.currentWaveData.b[i] = data.data.data.current_wave_ub[i] * 0.001
              this.currentWaveData.c[i] = data.data.data.current_wave_uc[i] * 0.001
            }
            this.rangeoption1.yAxis[0].name = 'kV'

            if ((max * 0.001) < 10) {
              this.rangeoption1.yAxis[0].max = Math.ceil(max * 0.001)
              this.rangeoption1.yAxis[0].min = Math.ceil(max * 0.001) * -1
            } else if ((max * 0.001) < 100) {
              this.rangeoption1.yAxis[0].max = Math.ceil(max * 0.0001) * 10
              this.rangeoption1.yAxis[0].min = Math.ceil(max * 0.0001) * 10 * -1
            } else {
              this.rangeoption1.yAxis[0].max = Math.ceil(max * 0.00001) * 100
              this.rangeoption1.yAxis[0].min = Math.ceil(max * 0.00001) * 100 * -1
            }
          } else {
            this.currentWaveData.a = data.data.data.current_wave_ua
            this.currentWaveData.b = data.data.data.current_wave_ub
            this.currentWaveData.c = data.data.data.current_wave_uc
            this.rangeoption1.yAxis[0].name = 'V'

            if (max < 10) {
              this.rangeoption1.yAxis[0].max = Math.ceil(max)
              this.rangeoption1.yAxis[0].min = Math.ceil(max) * -1
            } else if (max < 100) {
              this.rangeoption1.yAxis[0].max = Math.ceil(max * 0.1) * 10
              this.rangeoption1.yAxis[0].min = Math.ceil(max * 0.1) * 10 * -1
            } else {
              this.rangeoption1.yAxis[0].max = Math.ceil(max * 0.01) * 100
              this.rangeoption1.yAxis[0].min = Math.ceil(max * 0.01) * 100 * -1
            }
          }
        }

        this.rangeoption1.series[0].data = this.currentWaveData.a
        this.rangeoption1.series[1].data = this.currentWaveData.b
        this.rangeoption1.series[2].data = this.currentWaveData.c
        this.Chart.setOption(this.rangeoption1)
      } else if (this.posSelectValue === 2) {
        params.collection = 'meter_current_data'
        params.fields = ['current_wave_ia', 'current_wave_ib', 'current_wave_ic', 'current_wave_in']
        data = await this.$api.queryLastData(params)
        if (data.data.code !== 0) {
          this.$message.error(data.data.msg)
        } else {
          for (let i = 0; i < data.data.data.current_wave_ia.length; i++) {
            if (max < data.data.data.current_wave_ia[i]) max = data.data.data.current_wave_ia[i]
            if (max < data.data.data.current_wave_ib[i]) max = data.data.data.current_wave_ib[i]
            if (max < data.data.data.current_wave_ic[i]) max = data.data.data.current_wave_ic[i]
            if (max < data.data.data.current_wave_in[i]) max = data.data.data.current_wave_in[i]
          }
          if (max > 1000) {
            for (let i = 0; i < data.data.data.current_wave_ia.length; i++) {
              this.currentWaveData.a[i] = data.data.data.current_wave_ia[i] * 0.001
              this.currentWaveData.b[i] = data.data.data.current_wave_ib[i] * 0.001
              this.currentWaveData.c[i] = data.data.data.current_wave_ic[i] * 0.001
              this.currentWaveData.n[i] = data.data.data.current_wave_in[i] * 0.001
            }
            this.rangeoption2.yAxis[0].name = 'kA'

            if ((max * 0.001) < 10) {
              this.rangeoption2.yAxis[0].max = Math.ceil(max * 0.001)
              this.rangeoption2.yAxis[0].min = Math.ceil(max * 0.001) * -1
            } else if ((max * 0.001) < 100) {
              this.rangeoption2.yAxis[0].max = Math.ceil(max * 0.0001) * 10
              this.rangeoption2.yAxis[0].min = Math.ceil(max * 0.0001) * 10 * -1
            } else {
              this.rangeoption2.yAxis[0].max = Math.ceil(max * 0.00001) * 100
              this.rangeoption2.yAxis[0].min = Math.ceil(max * 0.00001) * 100 * -1
            }
          } else {
            this.currentWaveData.a = data.data.data.current_wave_ia
            this.currentWaveData.b = data.data.data.current_wave_ib
            this.currentWaveData.c = data.data.data.current_wave_ic
            this.currentWaveData.n = data.data.data.current_wave_in
            this.rangeoption2.yAxis[0].name = 'A'

            if (max < 10) {
              this.rangeoption2.yAxis[0].max = Math.ceil(max)
              this.rangeoption2.yAxis[0].min = Math.ceil(max) * -1
            } else if (max < 100) {
              this.rangeoption2.yAxis[0].max = Math.ceil(max * 0.1) * 10
              this.rangeoption2.yAxis[0].min = Math.ceil(max * 0.1) * 10 * -1
            } else {
              this.rangeoption2.yAxis[0].max = Math.ceil(max * 0.01) * 100
              this.rangeoption2.yAxis[0].min = Math.ceil(max * 0.01) * 100 * -1
            }
          }
        }

        this.rangeoption2.series[0].data = this.currentWaveData.a
        this.rangeoption2.series[1].data = this.currentWaveData.b
        this.rangeoption2.series[2].data = this.currentWaveData.c
        this.rangeoption2.series[3].data = this.currentWaveData.n
        this.Chart.setOption(this.rangeoption2)
      }
      // console.log(this.currentWaveData)
    }
  }
}
</script>

<template>
  <div class="page">
    <div class="dataBorder">
      <div class="pg">
        <div class="dataItems">
          <div class="title" style="height: 60px; line-height: 60px;">实时波形</div>

          <div style="width: 100%; display: flex; height: 35px; line-height: 35px;">
            <div
              style="width: 20%; display: flex; align-items: center; margin-left: 20px;">
              <div style="width: 100px">电气量选择</div>
              <div style="width: 150px; margin-left: 20px">
                <el-select v-model="posSelectValue" placeholder="请选择">
                  <el-option
                    v-for="item in posSelectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="height: calc(100% - 90px);">
            <div id="rangeOptions" style="height: 100%; width: 100%"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../assets/css/stable.css";

.page {
  width: 100%;
  height: 100%;
}

.dataBorder {
  margin: 10px;
  width: calc(100% - 20px);
  height: calc(90vh - 135px);
//overflow: auto; display: flex; flex-wrap: wrap; justify-content: space-between; font-size: 20px;
}

.pg {
  width: 98%;
  height: calc(90vh - 50px);
}

.dataName {
  width: 15%;
}

.dataValue {
  width: 8%;
//border-right: 1px solid black;
}

.dataNvItem {
  height: calc((100% - 70px) / 11);
}
</style>



// WEBPACK FOOTER //
// src/pages/Realtime/Realtime.vue